import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Eliminate from '../Component/Modal/Eliminate'
import { useLanguage } from '../Providers/LanguageContext';
import { UserContext } from '../Providers/UserWrapper';
import { AiOutlineCopy } from "react-icons/ai"
import { toast } from 'react-hot-toast';
import { SpeechContext } from '../Providers/SpeechWrapper';
import config_en1 from "../extras/x_share_account_code_audio_a.mp3";
import config_es1 from "../extras/x_share_account_code_audio_a_es.mp3";
import HttpClient from '../utils/HttpClient';

function Configaration() {
  const navigate = useNavigate();
  const { language, currentLanguage } = useLanguage()
  const { currAudio, setCurrAudio, playing } = useContext(SpeechContext);

  const [openModal, setOpenModal] = useState(false);
  const { profileData, getProfile } = useContext(UserContext);

  const [accCode, setAccCode] = useState("");
  const [imageUploadLoader, setImageUploadLoader] = useState(false);

  const [values, setValues] = useState({
    name: "",
    surName: "",
    phoneNumber: "",
    country: "",
    cp: "",
    city: "",
    state: "",
    profilePicture: "",
  })

  useEffect(() => {
    window.scrollTo({ top: '0', behavior: 'instant' })
  }, [])
  useEffect(() => {
    if (profileData) {
      if (profileData.name) {
        setValues(prev => ({ ...prev, name: profileData.name }))
      }
      if (profileData.surName) {
        setValues(prev => ({ ...prev, surName: profileData.surName }))
      }
      if (profileData.phoneNumber) {
        setValues(prev => ({ ...prev, phoneNumber: profileData.phoneNumber }))
      }
      if (profileData.country) {
        setValues(prev => ({ ...prev, country: profileData.country }))
      }
      if (profileData.cp) {
        setValues(prev => ({ ...prev, cp: profileData.cp }))
      }
      if (profileData.city) {
        setValues(prev => ({ ...prev, city: profileData.city }))
      }
      if (profileData.state) {
        setValues(prev => ({ ...prev, state: profileData.state }))
      }
      if (profileData.profilePicture) {
        setValues(prev => ({ ...prev, profilePicture: profileData.profilePicture }))
      }
      if (profileData.accountRegCode) {
        setAccCode(profileData.accountRegCode)
      }
    }
  }, [profileData]);

  // console.log("profileData: ", profileData);
  

  if (profileData && !profileData.name) {
    navigate("/configuration");
  }


  useEffect(() => {
    if (playing) {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause()
        }
      }
      if (currentLanguage === "eng") {
        setCurrAudio(new Audio(config_en1))
      } else {
        setCurrAudio(new Audio(config_es1))
      }
    } else {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause()
          setCurrAudio(null)
        }
      }
    }

    return () => {
      if (currAudio && !currAudio.paused) {
        currAudio.pause()
      }
    }
  }, [playing, currentLanguage])


  // useEffect(() => {
  //   if (currAudio) {
  //     if (!currAudio.paused) {
  //       currAudio.pause()
  //     }
  //     currAudio.play()
  //   }
  //   return () => {
  //     if (currAudio && !currAudio.paused) {
  //       currAudio.pause()
  //     }
  //   }
  // }, [currAudio])

  const handleChange = (e) => {
    setValues(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleUpdate = async () => {
    const vals = Object.values(values);
    let isErr = false;
    for (let val of vals) {
      if (!val) {
        isErr = true
      }
    }
    if (isErr) {
      toast.error(language.please_enter)
      return
    }
    const res = await HttpClient.requestData("update", "PUT", values);
    if (res && res.success) {
      toast.success(language.profile_update_success)
      getProfile();
    } else {
      toast.error(language.profile_update_error)
    }

  };

  const fileInputRef = useRef(null);


  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageUploadLoader(true);
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await HttpClient.fileUplode(
        'upload',
        'POST',
        formData,
      );

      if (response && response.status) {
        setValues(prev => ({
          ...prev,
          profilePicture: response.data.url,
        }));
        toast.success(response?.message || "Profile picture uploaded successfully");

        // Reset the file input after successful upload
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      } else {
        toast.error(response?.message || "Failed to upload logo");
        setValues(prev => ({
          ...prev,
          profilePicture: "",
        }));
        // Also reset on failure to allow retry
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    } catch (error) {
      console.error("Error uploading logo:", error);
      toast.error(error?.message ?? "Error uploading logo");
      setValues(prev => ({
        ...prev,
        profilePicture: "",
      }));
      // Reset on error too
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } finally {
      setImageUploadLoader(false);
    }
  };

  return (

    <>
      {/* <div className="try_fisibilty_wrapper " style={{
        transform: 'translateY(0%)',
        margin: '0px',
        justifyContent: 'start',
        background: '#031f31ff'

      }}>
        <div className="container-fluid">
          <p className="text-left">User Manager / Update User</p></div>
      </div> */}

      {/* <div id='config-head'>
        <div className='container'>
          <div className='config-heading'>
            <h4>{language.profile_settings}</h4>
          </div>
        </div>
      </div> */}

      <div className='pt-3' style={{
        background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',

      }}>
        <div className='container-fluid'>
          <div className='task_head'>Share Account Code</div>
        </div>
        <div className='container-fluid mt-3'>
          <button className='slctUser' style={{
            background: 'rgb(136, 233, 132)',
            fontWeight: '500',
            color: '#0c2637'
          }}
            onClick={() => navigate('/users')}>
            {language.manage_users}
          </button>
        </div>
        <div id='config-form'>
          <div className='container-fluid ' style={{
            border: '4px solid #fff',
            borderRadius: '25px',
            padding: '20px 20px',
            marginBottom: '40px',
            marginTop: '15px'
          }}>

            <div className='inner-container'>
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    value={values.name}
                    onChange={handleChange}
                    name="name"
                    placeholder={language.name}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='surName'
                    onChange={handleChange}
                    value={values.surName}
                    placeholder={language.surname}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='phoneNumber'
                    onChange={handleChange}
                    value={values.phoneNumber}
                    placeholder={language.phone_number}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='country'
                    onChange={handleChange}
                    value={values.country}
                    placeholder={language.country}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='cp'
                    onChange={handleChange}
                    value={values.cp}
                    placeholder="pin"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='city'
                    onChange={handleChange}
                    value={values.city}
                    placeholder={language.city}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    name='state'
                    onChange={handleChange}
                    value={values.state}
                    placeholder={language.state}
                  />
                </div>
                <div className="form-group">
                  {/* Label and image preview for the current profile picture */}
                  <label style={{ color: '#fff', display: 'block' }}>{language.Profile_Picture}</label>
                  {values.profilePicture && (
                    <img
                      src={values.profilePicture}
                      alt="Profile preview"
                      style={{ maxWidth: '100px', maxHeight: '100px', marginBottom: '10px', display: 'block' }}
                    />
                  )}

                  {/* The file input - Remove the 'value' prop */}
                  <input
                    type="file"
                    className="form-control"
                    id="profilePictureInput" // Added an id for better targeting if needed
                    name="profilePicture"
                    onChange={handleFileUpload}
                    placeholder={language.Profile_Picture}
                    accept="image/*"
                    ref={fileInputRef}
                  // value={values.profilePicture} // REMOVE THIS LINE
                  />
                  {/* Optional: Show loader during upload */}
                  {imageUploadLoader && <p>Uploading...</p>}
                </div>
                <div className="form-group" style={{ position: "relative" }}>
                  <label style={{
                    color: '#fff'
                  }}>{language.account_code}</label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby=""
                    value={accCode}
                    disabled
                    placeholder={language.account_code}
                  />
                  <span
                    style={{ position: "absolute", right: 10, bottom: 12 }}
                    onClick={() => {
                      navigator?.clipboard?.writeText(accCode)
                      toast.success(language.copy_clipboard)
                    }}
                  >
                    <AiOutlineCopy size={25} />
                  </span>
                </div>
              </form>
              <div className='d-flex justify-content-center align-items-center'>
                <button className='customBtn4' style={{
                  width: '250px',
                  height: "50px",
                  borderRadius: '10px'
                }} onClick={handleUpdate}>{language.update}</button>
              </div>

              <div className='config-btn d-flex justify-content-center' style={{ cursor: 'pointer' }}>
                <a className='eliminate-btn' onClick={() => { setOpenModal(true) }}>{language.eliminate}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openModal && <Eliminate closeModal={setOpenModal} />}
    </>
  )
}

export default Configaration